import { NString } from '@mobalytics/shared';
import { TRIAL_ONE_TIME_OFFER_LOL, TRIAL_ONE_TIME_OFFER_TFT } from '../../../constants';
import { ProductAbbreviation } from '../../../types/product';

export const getTrialOneTimeOfferByGame = (productAbbreviation: NString): string => {
  switch (productAbbreviation) {
    case ProductAbbreviation.LOL:
      return TRIAL_ONE_TIME_OFFER_LOL;
    case ProductAbbreviation.TFT:
      return TRIAL_ONE_TIME_OFFER_TFT;
    default:
      return '';
  }
};
